module.exports = __webpack_public_path__ + "static/media/pro1212.5870c225.jpg";